exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3MmM1N0M8WgUq3eoB_zgHY {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"button": "_3MmM1N0M8WgUq3eoB_zgHY"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/js/standard/StepBackButton/styles.scss
// module id = 54
// module chunks = 0